module.exports = __webpack_public_path__ + "img/live-curr.1190f45c.gif";